/* eslint-disable arrow-body-style */
import React from 'react';

import { Button } from '@abyss/web/ui/Button';
import {
  linkAnalysisFilterPanelApi,
  useLinkAnalysisFilterPanelStore,
} from '../../mothership/linkAnalysisFilterPanel.state';
import { linkAnalysisId } from '../../types';

export const SearchButton = () => {
  const testId = `${linkAnalysisId}SearchBtn`;
  const enabled = useLinkAnalysisFilterPanelStore(
    (state) => state.searchBtnEnabled
  );
  const { submit } = linkAnalysisFilterPanelApi;

  return (
    <Button
      data-testid={testId}
      data-cy={testId}
      id="filterPanelSearchBtn"
      variant="solid"
      disabled={!enabled}
      onClick={submit}
    >
      Search
    </Button>
  );
};
